import { Box, Select, SelectProps } from '@mantine/core';

import InputLabel from 'components/input-label';
import classes from './index.module.css';

interface ICustomSelect extends SelectProps {
  info?: string;
  label: string;
}

const CustomSelect = ({
  clearable = true,
  info,
  label,
  required,
  ...props
}: ICustomSelect) => {
  return (
    <Box>
      <InputLabel label={label} required={required} info={info} />
      <Select
        classNames={{ input: classes.input }}
        mb={6}
        clearable={clearable}
        {...props}
        value={props.value}
      />
    </Box>
  )
}

export default CustomSelect;